import { apiPost } from '../client';
import type {
  GetShoppingCartRequest,
  ShoppingCartResponse,
  UnlockShoppingCartRequest,
  VoidRequest,
} from '../types/shoppingCart';
import type { ResponseBase } from '../types/common';

export function getShoppingCart(shoppingCartId: string): Promise<ShoppingCartResponse> {
  return apiPost<GetShoppingCartRequest, ShoppingCartResponse>('GetShoppingCart', { shoppingCartId });
}

/** Not wired to any screen (the standalone "Sepet" utility page was removed) — kept as a
 *  thin wrapper in case a cart-admin screen needs it again. */
export function unlockShoppingCart(shoppingCartId: string): Promise<ResponseBase> {
  return apiPost<UnlockShoppingCartRequest, ResponseBase>('UnlockShoppingCart', { shoppingCartId });
}

/** Generic `/Void` — void an issued ticket (`ReservationDetailPage`, ticket state). The
 *  backend `VoidResponse` returns the mutated cart, so the ticket flow can read
 *  `shoppingCart.processHistories` off it; the airline's void window is enforced
 *  server-side ("Void etme süresi geçmiştir."). */
export function voidShoppingCart(
  shoppingCartId: string,
  extra?: Omit<VoidRequest, 'shoppingCartId'>
): Promise<ShoppingCartResponse> {
  return apiPost<VoidRequest, ShoppingCartResponse>('Void', { shoppingCartId, ...extra });
}
